// SEO Head component for consistent SEO metadata
import { Helmet } from 'react-helmet-async'
import { getCanonicalUrl } from '@/utils/seo'
import { useTranslation } from 'react-i18next'

interface SEOHeadProps {
  title: string
  description?: string
  canonical?: string
  ogImage?: string
  ogType?: string
  noindex?: boolean
}

export default function SEOHead({
  title,
  description,
  canonical,
  ogImage,
  ogType = 'website',
  noindex = false,
}: SEOHeadProps) {
  const { t } = useTranslation()
  const brandName = t('brand.name', 'سكينة')
  const fullTitle = `${title} - ${brandName}`
  const canonicalUrl = canonical ? getCanonicalUrl(canonical) : window.location.href

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl || window.location.href} />
      <meta property="og:site_name" content={brandName} />
      {ogImage && <meta property="og:image" content={ogImage} />}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {/* Language and direction are handled dynamically by applyDirection() */}
    </Helmet>
  )
}
